import React, { useState } from 'react';
import ModalTerms from 'components/Popup/ModalTerms';
import { GetTermsAPI } from 'api/site';
import { siteActions } from 'store/site';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import TransferOfPersonalInformation from 'components/Popup/TransferOfPersonalInformation';
import Modal from './Modal';
import { DrawerSideOptions } from '../../constants';

const FooterContainer = styled.footer`
  position: relative;
`;

const DDPSLink = styled.div`
  &.desktop-link {
    position: absolute;
    top: 20px;
    right: 0;
    
    @media (max-width: 768px) {
      display: none;
    }
  }
  
  &.mobile-link {
    display: none;
    
    @media (max-width: 768px) {
      display: block;
      margin-top: 20px;
      text-align: left;
    }
  }
  
  a {
    font-weight: bold;
    color: inherit;
    text-decoration: none;
  }
`;

const FooterContent = styled.div`
  @media (min-width: 769px) {
    padding-right: 300px;
  }
`;

const Footer: React.FC = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { openModal, ModalPortal, closeModal } = Modal();
  const [showTerms, setShowTerms] = useState(false);
  const [
    showTransferOfPersonalInformation,
    setShowTransferOfPersonalInformation,
  ] = useState(false);


  // 개인정보처리방침: DDPS 약관 페이지로 연결 (DDPS 요청, 2026-06)
  const openTermsPrivate = () => {
    window.open('https://dndproperty.com/pages/localstitch');
  };

  const handleOpenTermsPopup = async (type: string) => {
    const { data } = await GetTermsAPI(type);
    dispatch(siteActions.getTerm(data));
    setShowTerms(true);
    openModal();
  };

  const handleCloseTermsPopup = () => {
    setShowTerms(false);
    closeModal();
  };

  const handleOpenTransferOfPersonalInformationPopup = () => {
    setShowTransferOfPersonalInformation(true);
    openModal();
  };

  const handleCloseTransferOfPersonalInformationPopup = () => {
    setShowTransferOfPersonalInformation(false);
    closeModal();
  };

  return (
    <>
      <FooterContainer>
        <DDPSLink className="desktop-link">
          <a
            href="https://www.dndproperty.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            DDPS | D&D Property Solution
          </a>
        </DDPSLink>
        
        <FooterContent>
          <div id="ftrInfo" className="ftr-inner">
            <ul>
              <li onClick={() => handleOpenTermsPopup('terms')}>
                <a style={{ cursor: 'pointer' }}>이용약관</a>
              </li>
              {/* 위치기반서비스 이용약관 숨김 처리
              <li onClick={() => handleOpenTermsPopup('locationterms')}>
                <a style={{ cursor: 'pointer' }}>위치기반서비스 이용약관</a>
              </li>
              */}
              <li onClick={() => openTermsPrivate()}>
                <a style={{ cursor: 'pointer' }}>개인정보처리방침</a>
              </li>
            </ul>
            <div>
              <div className="info">
                <em>디앤디프라퍼티솔루션(주)</em>
                <span>대표자 : 오영래</span>
                <span>
                  사업자등록정보 : 399-86-02542
                </span>
                <span>통신판매번호 : 2022-서울강남-05291</span>
              </div>
              <div className="addr-w">
                <address>주소 : 서울특별시 강남구 학동로 129</address>
                <span>전화 : 02-322-8601</span>
                <span>개인정보보호책임 : 정의진</span>
              </div>
            </div>
          </div>
          <p>
            COPYRIGHT 2023-2025 D&D PROPERTY SOLUTION CO., LTD ALL RIGHT RESERVED.
          </p>
          <div style={{ display: 'flex', marginTop: 16, flexWrap: 'wrap' }}>
            {DrawerSideOptions.map((option, index) => {
              return (
                <React.Fragment key={index}>
                  <span style={{ fontWeight: 'bold' }}>
                    {option.name === '채용' ||
                    option.name ===
                      '합병에 따른 채권자이의제출 및 주권제출 공고' ? (
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={option.href}
                      >
                        {option.name}
                      </a>
                    ) : option.name === '개인정보 이전 동의' ? (
                      <a onClick={handleOpenTransferOfPersonalInformationPopup}>
                        {option.name}
                      </a>
                    ) : (
                      <a onClick={() => router.push(option.href)}>
                        {option.name}
                      </a>
                    )}
                  </span>
                  {index < DrawerSideOptions.length - 1 && (
                    <span style={{ margin: '0 6px' }}>•</span>
                  )}
                </React.Fragment>
              );
            })}
          </div>
          <div style={{ display: 'flex', marginTop: 16, fontWeight: 'bold' }}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/localstitch/"
            >
              Instagram
            </a>
            <span style={{ margin: '0 6px' }}>|</span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://blog.naver.com/localstitchmaster"
            >
              Blog
            </a>
          </div>
        </FooterContent>
        
        {/* 모바일에서만 하단에 표시되는 링크 */}
        <DDPSLink className="mobile-link">
          <a
            href="https://www.dndproperty.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            DDPS | D&D Property Solution
          </a>
        </DDPSLink>
      </FooterContainer>
      <ModalPortal>
        {showTerms && <ModalTerms closeModal={handleCloseTermsPopup} />}
        {showTransferOfPersonalInformation && (
          <TransferOfPersonalInformation
            closeModal={handleCloseTransferOfPersonalInformationPopup}
          />
        )}
      </ModalPortal>
    </>
  );
};

export default Footer;
